// Browsers send warnings to Splunk, so logging here would fire once per page view.
// The server render and the native apps log the same removals.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const logRemovedLink = (metadata: Record<string, string>): void => {};
